const pathMap = [
    { path:'/reports/72', menu:'Reports' , submenu:'FORMS' }
];

export const getMenuNameByPath = (adminPortalLeftNav, path) =>{
    let submenu = '';    
    const lowerPath = (path || '').toLowerCase().replace('/app/','/');
    const mappedItem = pathMap.find((item) => item.path === lowerPath );
    if(mappedItem) {
        return {
            menuName: mappedItem.menu,
            submenuName: mappedItem.submenu
        };
    }
    else {
        let result = adminPortalLeftNav.find((item)=> {
            let partialResult = (item && item.subitems) ? item.subitems.find((subitem)=> {
                const lowerTo = (subitem.to || '').toLowerCase();
                return lowerPath === lowerTo;
            }) : null;
            
            if(partialResult) {
                submenu = partialResult.label;
                return true;
            }
            return false;
        });
        
        if(result) {
            return {
                menuName: result.label || '',
                submenuName: submenu
            };
        }           
    }
    return {
        menuName: '',
        submenuName: ''
    };
}